import {
  savePageControls,
  updatePagesCache,
  changeLayoutSwitch,
  completePageControls,
  clonePage,
  chooseFlow,
  addFlow,
  updateFlow,
  changeFlowInfo,
  deleteFlow,
  changeFlowNodes,
  setOpenLists,
  changeEditorFlowTabType
} from "$vuex/actions/app_actions";

import {
  cutSelectedControls,
  pasteSelectedControls,
  copySelectedControls,
  cancelSelectedControlOpera,
  resumeSelectedControlOpera,
  updateCustomAttrs,
  syncControls,
  selectControl,
  popSelectedControl,
  appendSelectedControl,
  selectControlItems,
  removeSomeControls,
  groupSelectedControls,
  unGroupSelectedControls,
  clearSelectedControls,
  clearModifiedControl,
  recordControlActions,
  updateChildrenIds,
  addElementControls,
  addStack,
  clearStack
} from "$vuex/actions/page_actions";

import { initTables } from "$vuex/actions/project_actions";

export default {
  vuex: {
    actions: {
      rulerShow: ({ dispatch }, show) => dispatch("SHOW_RULER", show),
      cutSelectedControls,
      copySelectedControls,
      pasteSelectedControls,
      cancelSelectedControlOpera,
      resumeSelectedControlOpera,
      savePageControls,
      updatePagesCache,
      changeLayoutSwitch,
      initTables,
      updateCustomAttrs,
      syncControls,
      selectControl,
      popSelectedControl,
      appendSelectedControl,
      selectControlItems,
      completePageControls,
      clonePage,
      removeSomeControls,
      groupSelectedControls,
      unGroupSelectedControls,
      clearSelectedControls,
      clearModifiedControl,
      // 流程图相关
      chooseFlow,
      addFlow,
      updateFlow,
      changeFlowInfo,
      deleteFlow,
      changeFlowNodes, // 修改选中流程图节点
      setOpenLists,
      changeEditorFlowTabType,
      recordControlActions,
      updateChildrenIds,
      // 添加局部爬虫
      addElementControls,
      addStack,
      clearStack
    },
    getters: {
      currentPage: state => state.page.pageInfo || {},
      errorStacks: state => state.page.errorStacks || [],
      projectInfo: state => state.project.info,
      userInfo: state => state.userInfo,
      controls: state => state.page.controls || [],
      controlsMap: state => state.page.controlsMap || [],
      pageMaps: state => state.app.pageMaps,
      appInfo: state => state.app.appInfo || {},
      isSpiderApp: state => state.page.pageInfo.layoutType === 5 || false,
      selectedControls: state => state.page.selectedControls,
      copyControls: state => state.page.copyControls,
      isRulerShow: state => state.editor.rulerShow,
      cancelSelectedControlOps: state => state.page.cancelSelectedControlOps,
      resumeSelectedControlOps: state => state.page.resumeSelectedControlOps,
      userInfo: state => state.userInfo,
      page: state => state.page,
      saveStatus: state => state.page.saveStatus,
      editType: state => state.app.editType || "page",
      controlDefines: state => state.editor.controlDefines,
      controlDefinesMap: state => state.editor.controlDefinesMap,
      pages: state => state.app.pages,
      events: state => state.events,
      modifiedControls: state => state.page.modifiedControls,
      initialFlowMap: state => state.app.initialFlowMap,
      flows: state => state.app.flows,
      currentFlow: state => state.app.currentFlow,
      currentNodes: state => state.app.currentNodes,
      flowOpenLists: state => state.app.flowOpenLists,
      showSetModal: state => state.page.showSetModal,
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/vuex.js